import * as React from 'react';

import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function BodyIntroduction() {
    return (
        <OnboardingBody title='Email marketing powered by CRM'>
            <div>
                <p>
                    Nutshell’s email marketing gives you marketing features that fit seamlessly into
                    your Nutshell toolkit, without the need for 3rd party integrations.
                    <br />
                    <br />
                    Send your audience beautiful emails that you can write, design, send, and report
                    on — right from Nutshell.
                    <br />
                    <br />
                    Before you get started, here are some important things you should know.
                </p>
            </div>
        </OnboardingBody>
    );
}
